<template>
  <div class="border p-4 h-100 bg-white" style="min-width: 300px; min-height: 800px">
    <h4>
      <b class="text-blue">Categorías</b>
    </h4>
    <ul class="pl-0 pt-4">
      <li class="text-primary" v-bind:class="categorySelected == '' ? 'font-weight-bold' : ''">
        <router-link class="text-decoration-none" :to="{name: kind}">
          <span class="material-icons icons text-blue">chevron_right</span>
          <span class="item-menu-category text-blue">Ver todos</span>
        </router-link>
      </li>
      <li
        class="text-secondary"
        v-for="category in categories"
        :key="category._id"
        v-bind:class="categorySelected == category._id ? 'font-weight-bold' : ''"
      >
        <router-link
          class="text-decoration-none"
          :to="{name: kind+'ByCategory', params: {category: category.name.replace(/[-]/g,'_').replace(/\s/g,'-')}}"
        >
          <span class="material-icons icon-chevron text-dark">chevron_right</span>
          <span
            class="text-capitalize item-menu-category"
            :class="$route.params.category == category.name.replace(/[-]/g,'_').replace(/\s/g,'-') ? 'text-danger-2 font-weight-bold' : 'text-dark'"
          >{{category.name}}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MenuCategory",
  props: {
    categories: Array,
    kind: String
  },
  data() {
    return {
      categorySelected: (this.categorySelected = this.$parent.categorySelected)
    };
  }
};
</script>
<style scoped lang="sass">
.item-menu-category
  padding-left: 0px
  padding-right: 5px
  transition: 0.2s
  &:hover
    color: #d31a00 !important
    padding-left: 5px
    padding-right: 0px
    font-weight: 700
</style>